import { render, staticRenderFns } from "./directInvest_Opportunities.vue?vue&type=template&id=4bf1c7e5&scoped=true"
import script from "./directInvest_Opportunities.vue?vue&type=script&lang=js"
export * from "./directInvest_Opportunities.vue?vue&type=script&lang=js"
import style0 from "./directInvest_Opportunities.vue?vue&type=style&index=0&id=4bf1c7e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf1c7e5",
  null
  
)

export default component.exports